export default __webpack_public_path__ + "static/media/no-user.35f98e8b.svg";